'use client';
import React, { useEffect, useState } from 'react';
import AppBar from '@pezeshk-book/ui-kit/app-bar';
import classNames from '@pezeshk-book/ui-kit/utils/helpers/class-names';
import Div from '@pezeshk-book/ui-kit/div';
import Media from '@pezeshk-book/ui-kit/media';
import Banner from '@layouts/banner';
import LoginModal from '@layouts/login-modal';
import { useDebouncedCallback } from 'use-debounce';
import ResponsiveHeader from './responsive-header';
import DesktopHeader from './desktop-header';
import { useParams, usePathname } from 'next/navigation';

const RoutesWithoutHeader = [
  'onlineland',
  '/adsland',
  '/landingp',
  '/maintenance',
  '/serviceph',
];
const Header = () => {
  const [shouldHideHeader, setShouldHideHeader] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const currentRoute = usePathname();
  const params = useParams<{ slug: string }>();

  const RoutesWithoutBanner = [
    '/',
    '/posts',
    `/posts/${params.slug}`,
  ];

  useEffect(() => {
    window.addEventListener('scroll', handleDocumentScrollBounced);

    return () =>
      window.removeEventListener('scroll', handleDocumentScrollBounced);
  }, []);

  const handleDocumentScroll = async () => {
    const { scrollTop: currentScrollTop } = document.documentElement || document.body;

    const prePosition = shouldHideHeader ? currentScrollTop + 64 : currentScrollTop - 64;
    setShouldHideHeader(scrollPosition < prePosition && prePosition > 86);
    setScrollPosition(prePosition);
  };

  const handleDocumentScrollBounced = useDebouncedCallback(handleDocumentScroll, 300);

  if (RoutesWithoutHeader.indexOf(currentRoute) !== -1) {
    return null;
  }

  return (
    <>
      <AppBar position={'sticky'} className={'flex-col items-center justify-center'}>
        {RoutesWithoutBanner.indexOf(currentRoute) !== -1 && process.env.ADVERTISING_BANNER_SHOW === 'true' ? (
          <Div className={classNames(
            'w-full transition-[margin] duration-1000 ease-in-out inline-block z-[19]',
            shouldHideHeader ? 'sm:-mt-8 md:-mt-12' : ''
          )}>
            <Banner/>
          </Div>
        ) : null}
        <Div className={'w-full max-w-[1400px] justify-center'}>
          <Media className={'flex items-center w-full'} greaterThan={'sm'}>
            <Div className={classNames(
              'transition-all w-full self-center',
              shouldHideHeader ? 'pt-0 bg-transparent' : 'bg-white pt-4'
            )}>
              <DesktopHeader/>
            </Div>
          </Media>
          <Media className={'flex items-center w-full'} lessThan={'md'}>
            <ResponsiveHeader/>
          </Media>
        </Div>
      </AppBar>
      <LoginModal/>
    </>
  );
};

export default Header;

